<template>
    <div class="relative bg-white text-black pt-28" :class="$device.isDesktop ? 'lg:pt-52' : 'lg:pt-40'">
        <div class="container grid grid-cols-12 gap-5 pb-20">
            <div class="col-span-12 lg:col-span-10 lg:col-start-2 xl:col-span-8 xl:col-start-3">
                <h1 class="title title-xl mb-8">
                    {{ model.title }}
                </h1>

                <div class="flex flex-col xs:flex-row mb-12 sm:mb-18">
                    <span>
                        <i class="pi pi-clock mr-1"></i>
                        {{ model.minutes_to_read }} {{ $tc('generic.minute_to_read', model.minutes_to_read) }}
                    </span>
                </div>

                <p class="mb-12">{{ model.lead }}</p>

                <img :src="model.cover_image_cropped" :alt="model.title" class="w-full mb-12" />

                <div class="tinymce-content" v-html="model.body"></div>

                <SectionDownloadables v-if="model.downloads" :attachments="model.downloads" />

                <div class="flex flex-col-reverse sm:flex-row sm:justify-between sm:items-center pt-12 md:mt-16">
                    <NuxtLink
                        :to="getBackButtonPath()"
                        class="p-component p-button p-button-secondary p-button-text mt-12 sm:mt-0"
                    >
                        <span class="pi pi-arrow-left p-button-icon p-button-icon-left"></span>
                        <span class="p-button-label">Vissza</span>
                    </NuxtLink>

                    <div class="flex flex-col sm:flex-row sm:items-center">
                        <div class="sm:mr-3 mb-5 sm:mb-0">Megosztom</div>
                        <ArticleShareButtonGroup :title="model.title" />
                    </div>
                </div>
            </div>
        </div>

        <div v-if="model.related && model.related.length" class="bg-gray-800 text-white pt-10 sm:pt-16 pb-5 sm:pb-20">
            <SectionWrapper
                title="További híreink"
                :link="{ path: localePath('/news'), label: 'Hírek, további cikkek' }"
                class="container px-0"
                is-carousel-wrapper
            >
                <ArticleCarousel :articles="model.related" />
            </SectionWrapper>
        </div>
    </div>
</template>

<script>
import SectionWrapper from '../UI/SectionWrapper';
import ArticleShareButtonGroup from '@/components/UI/Buttons/ArticleShareButtonGroup';
import SectionDownloadables from '@/components/Sections/SectionDownloadables/SectionDownloadables';
import ArticleCarousel from '@/components/Carousels/ArticleCarousel';

export default {
    name: 'NewsArticle',
    components: {
        ArticleShareButtonGroup,
        SectionWrapper,
        SectionDownloadables,
        ArticleCarousel,
    },
    props: {
        model: {
            type: Object,
            required: true,
        },
    },
    mounted() {
        this.$store.commit('globals/setAlternateUrlsForCurrentPage', [
            {
                key: 'fallback',
                path: '/news',
            },
        ]);
    },
    beforeDestroy() {
        this.$store.commit('globals/setAlternateUrlsForCurrentPage', null);
    },
    methods: {
        getBackButtonPath() {
            // this looks for the last query param handed over from /news, namely the 'page' route query.
            const query = this.$store.state.jobs.lastSearchQuery;
            return this.localePath(query ? `/news?${new URLSearchParams(query).toString()}` : '/news');
        },
    },
};
</script>

<style scoped></style>
